import { render, staticRenderFns } from "./TaskPanelModal.vue?vue&type=template&id=ac8e2534&lang=pug&"
import script from "./TaskPanelModal.vue?vue&type=script&lang=js&"
export * from "./TaskPanelModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskPanelModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaskPanelModal.vue"
export default component.exports